var generateStyle = function generateStyle(componentTheme) {
  return {
    headerRows: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      maxWidth: "calc(".concat(componentTheme.maxContentWidth, " + ").concat(componentTheme.headerPadding, " * 2)"),
      margin: '0 auto'
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: componentTheme.headerPadding,
      paddingRight: componentTheme.headerPadding
    },
    buttons: {
      display: 'flex'
    },
    button: {
      padding: '0.5rem',
      '&:last-of-type': {
        paddingRight: '0'
      }
    }
  };
};
export default generateStyle;